export default "__VITE_ASSET__DEYYfcn9__"